import { Modal } from '@joor/design-system'
import styled, { keyframes } from 'styled-components'

const fadeInSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

export const KeyframeModal = styled(Modal)`
  animation: ${fadeInSlideUp} 0.2s ease-out forwards;
`

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
